import { enumFilesAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideFile } from 'lucide-react';

import {
  $remoteFilesOutboxEventCounts,
  useFilesAggregateTypeFilter,
} from '@/audit-log/_state/filesEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumFilesAggregateType.File,
    labelKey: 'file' as const,
    icon: LucideFile,
    countKey: 'file' as const,
  },
];

export const FilesEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useFilesAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue(
    $remoteFilesOutboxEventCounts,
  );

  const totalCount = counts ? counts.file : 0;

  return (
    <Col className="@FilesEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.filesEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.filesEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
